import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useMorningCustomers } from '../../../../../hooks/requests/integrations';
import { useExternalCustomerSelection } from '../../hooks/use-external-customer-selection';

export const useMorningCustomerSelection = () => {
  const { customers, ...rest } = useExternalCustomerSelection({
    provider: INTEGRATION_PROVIDERS.morning,
    useCustomersHook: useMorningCustomers,
  });

  return {
    morningCustomers: customers,
    ...rest,
  };
};
